<template>
  <div class="ibox">
    <div class="tabs-container">
      <ul class="nav nav-tabs" role="tablist">
        <li class="active"><a class="nav-link" data-toggle="tab" href="#userlog" @click="activeComponent='tabUserLog'"><i class="fa fa-newspaper-o"></i> Activity Log </a></li>
      </ul>
      <div class="tab-content">
        <div class="tab-pane ibox-content active" >
          <div class="row" v-if="activeComponent">
            <component v-show="false" :is="activeComponent"></component>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import UserLog from './Tabs/UserLog'
export default {
  data () {
    return {
      activeComponent: 'tabUserLog'
    }
  },
  components: {
    tabUserLog: UserLog
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Admin/Role/Content.vue